import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { Customer } from './customer';

@JsonObject('CustomerResponcePage')
export class CustomerResponcePage extends ResponcePage {

    @JsonProperty([Customer], 'content')
    content: Customer[];
}